module.exports = __webpack_public_path__ + "img/housewares.3446f338.svg";